/*
 * ATTENTION: An "eval-source-map" devtool has been used.
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file with attached SourceMaps in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => {
  // webpackBootstrap
  /******/ var __webpack_modules__ = {
    /***/ "./src/js/sections/collection-page.js":
      /*!********************************************!*\
  !*** ./src/js/sections/collection-page.js ***!
  \********************************************/
      /***/ () => {
        eval(
          'const activeCollection = document.querySelector(".collection__tab.active");\nconst blockCollection = document.querySelector(".collection__tabs-mobile");\n\nactiveCollection.addEventListener("click", (e) => {\n  e.preventDefault();\n  blockCollection.classList.toggle("is-show");\n});\n//# sourceURL=[module]\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiLi9zcmMvanMvc2VjdGlvbnMvY29sbGVjdGlvbi1wYWdlLmpzLmpzIiwibWFwcGluZ3MiOiJBQUFBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBIiwic291cmNlcyI6WyJ3ZWJwYWNrOi8vbGVhcm4td2VicGFjay8uL3NyYy9qcy9zZWN0aW9ucy9jb2xsZWN0aW9uLXBhZ2UuanM/ZjQ1YyJdLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBhY3RpdmVDb2xsZWN0aW9uID0gZG9jdW1lbnQucXVlcnlTZWxlY3RvcihcIi5jb2xsZWN0aW9uX190YWIuYWN0aXZlXCIpO1xuY29uc3QgYmxvY2tDb2xsZWN0aW9uID0gZG9jdW1lbnQucXVlcnlTZWxlY3RvcihcIi5jb2xsZWN0aW9uX190YWJzLW1vYmlsZVwiKTtcblxuYWN0aXZlQ29sbGVjdGlvbi5hZGRFdmVudExpc3RlbmVyKFwiY2xpY2tcIiwgKGUpID0+IHtcbiAgZS5wcmV2ZW50RGVmYXVsdCgpO1xuICBibG9ja0NvbGxlY3Rpb24uY2xhc3NMaXN0LnRvZ2dsZShcImlzLXNob3dcIik7XG59KTtcbiJdLCJuYW1lcyI6W10sInNvdXJjZVJvb3QiOiIifQ==\n//# sourceURL=webpack-internal:///./src/js/sections/collection-page.js\n'
        );

        /***/
      },

    /******/
  };
  /************************************************************************/
  /******/
  /******/ // startup
  /******/ // Load entry module and return exports
  /******/ // This entry module can't be inlined because the eval-source-map devtool is used.
  /******/ var __webpack_exports__ = {};
  /******/ __webpack_modules__["./src/js/sections/collection-page.js"]();
  /******/
  /******/
})();
